import {connect} from 'react-redux';

import {makeMapStateToProps} from '../../../../../../../srcCommon/helpers/reselectHelpers';
import {ConversationBaseModel} from '../../../../../../models/api/conversationModel';
import {makeGetConversationsInboxes} from '../../../../../../store/data/conversations/conversationsSelectors';
import {CellsContext} from '../../../../../../store/panels/cells/context/cellsContext';
import {InboxesParameters} from '../../../../../../store/panels/inboxes/parameters/inboxesParameters';
import {ViewerPanelId} from '../../../../../../store/panels/panelStateBase';
import {ConversationsMoveCoordinator} from './conversationsMoveCoordinator';

/*
 * Props.
 */

interface ConversationsMoveCoordinatorContainerProps {
  panelId: ViewerPanelId;
  cellsContext: CellsContext;
  inboxesParameters: InboxesParameters;
  /** Potentially partial set of currently selected conversation. */
  conversations: ReadonlyArray<ConversationBaseModel>;
  isBulkActionRequired: boolean;
}

/*
 * Selectors.
 */

function getConversations(_state: unknown, props: ConversationsMoveCoordinatorContainerProps) {
  return props.conversations;
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<ConversationsMoveCoordinatorContainerProps>()(() => ({
  conversationInboxes: makeGetConversationsInboxes(getConversations),
}));

export const ConversationsMoveCoordinatorContainer = connect(mapStateToProps)(ConversationsMoveCoordinator);
